export default __webpack_public_path__ + "static/media/goopter-promobot-display-ads.f6900894.jpg";